/* Product Modal Fix v2 - scroll to clicked image, no flash */
(function() {
  if (!document.querySelector('product-modal')) return;

  /* Inject a tiny CSS rule: hide modal content until ready */
  var style = document.createElement('style');
  style.textContent = '.product-media-modal__content.tp-hidden { opacity: 0 !important; }';
  document.head.appendChild(style);

  document.querySelectorAll('modal-opener button[data-media-id]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var mediaId = this.getAttribute('data-media-id');
      if (!mediaId) return;

      /* Hide modal content immediately */
      var content = document.querySelector('.product-media-modal__content');
      if (content) content.classList.add('tp-hidden');

      /* Poll for modal open, then scroll and reveal */
      var attempts = 0;
      var check = setInterval(function() {
        attempts++;
        var modal = document.querySelector('product-modal');
        if (!modal || !modal.hasAttribute('open')) {
          if (attempts > 50) clearInterval(check);
          return;
        }
        clearInterval(check);
        var c = modal.querySelector('.product-media-modal__content');
        if (!c) return;
        var target = c.querySelector('img[data-media-id="' + mediaId + '"]');
        if (target) {
          target.scrollIntoView({ behavior: 'instant', inline: 'start', block: 'start' });
        }
        /* Reveal after a micro-delay to let scroll complete */
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            c.classList.remove('tp-hidden');
          });
        });
      }, 10);
    });
  });
})();